import { z } from "zod";
import apiProductDataSchema from "./apiProductDataSchema";
import { vector2dSchema } from "../primitivesSchema";

const apiSpaceDataSchema = apiProductDataSchema.extend({
    apartmentId: z.string(),
    centroid: vector2dSchema
  });

export default apiSpaceDataSchema;